import { Component, computed, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AssistantToolLine } from '@core/models/assistant/assistant.model';
import { ICONS } from '@core/services/icons/icons.service';

import {
  AssistantToolLineComponent,
  formatDuration
} from '../assistant-tool-line/assistant-tool-line.component';

/** The reading steps of one reply, folded into a single line that expands to each step. */
@Component({
  selector: 'app-assistant-tool-group',
  imports: [TranslatePipe, AssistantToolLineComponent],
  templateUrl: './assistant-tool-group.component.html',
  styles: ``
})
export class AssistantToolGroupComponent {
  readonly tools = input.required<AssistantToolLine[]>();
  readonly streaming = input(false);
  protected readonly ICONS = ICONS;
  protected readonly expanded = signal(false);
  protected readonly running = computed(() =>
    this.tools().filter((t) => t.status === 'running')
  );
  protected readonly duration = computed(() => {
    const ms = this.tools().reduce((sum, t) => sum + (t.durationMs ?? 0), 0);
    return ms > 0 ? formatDuration(ms) : null;
  });
  protected readonly header = computed(() => {
    const one = this.tools().length === 1;
    if (this.streaming())
      return one ? 'assistant.chrome.working_one_tool' : 'assistant.chrome.working';
    return one ? 'assistant.chrome.used_tool' : 'assistant.chrome.used_tools';
  });
}
